<template>
  <div class="section section-landpresale" id="landpresale-section" data-background-color="black" style="background-image: url('/img/img_main_land_data.png'); background-size: cover; background-position: center center; height: 100vh;">    
    <div data-aos="fade-up" data-aos-offset="-100" class="img_deco_06">
    </div> 
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="text-center col-md-12 col-lg-12">
          <h1 data-aos="fade-up" data-aos-offset="-300" class="title deco2">{{$t(`Land Data`)}}</h1>
          <div class="row">
            <div data-aos="fade-left" data-aos-offset="-500" style="margin-top: 80px; width: 100%; height: 222px; background-image: url('/img/bg_land_data.png'); background-size: cover; background-position: center center; padding-top: 70px;">
              <h6>{{$t(`land data desc1`)}}</h6>
              <h6>{{$t(`land data desc2`)}}</h6>
            </div>
            <div style="margin-top: 40px; width: 100%; text-align: center;">
              <n-button @click="goLand()"
                class="btn btn-main3 btn-wide btn-upper btn-lg"
              >
                {{$t('Go LandPortal')}}
              </n-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button } from '@/components';
export default {
  name: 'landdata',
  components: {
    [Button.name]: Button
  },
  methods: {
    goLand: async function() {
      let url = "//land.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, '_blank');
    }
  },
};
</script>
<style></style>
